import _ from "lodash";
export class NormalizeString {
    /**
     * @public
     * Normalize String to find in Collection - Remove diacricts and transform to Upper
     * @param {String} [value]
     * @return {String} normalized Str
     */
    static normalizeUpperCaseNd(value) {
        if (!value) return "";

        return value
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[./-]/g, "") // Remove pontos e barras
            .toUpperCase();
    }

    static classifierClean(classifier) {
        if (!classifier) return;

        classifier = classifier
            .toString()
            .split("")
            .reverse()
            .filter((value, index) => (value == "0" ? index % 2 == 0 : true))
            .reverse()
            .join("");

        return classifier;
    }

    static formatNameNdSearch(value) {
        if (!value) return null;

        return _.deburr(
            value.replace(/[\(,\),\-,\+,\=,\|,\%,\/]/gi, "").trim()
        ).toUpperCase();
    }

    static formatDocument(document) {
        if (!document) return "";

        //Remove tudo o que não é dígito
        document = document.replace(/\D/g, "");

        if (document.length <= 13) {
            //CPF
            document = document.replace(
                /(\d{3})(\d{3})(\d{3})(\d{2})/,
                "$1.$2.$3-$4"
            );
        } else {
            //CNPJ
            document = document.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                "$1.$2.$3/$4-$5"
            );
        }

        return document;
    }
}
